        class VariantSelectsManuly extends VariantSelects {
            constructor() {
                super();
            }

            connectedCallback() {
                this.addEventListener('click', (event) => {
                    let target = this.getInputForEventTarget(event.target);
                        var dis = target.parentNode.querySelectorAll("input")[0];
                        if(dis === undefined){
                          dis = target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelectorAll("input")[0];
                        }
                        if(dis === undefined) return;
                        dis = dis.hasAttribute("disabled");
                          
                        if (target.hasAttribute("watering") && event.pointerId > 0 && !dis) {

                            var notChecked = target.parentNode.querySelector('input:not([checked])');
                            var checked = target.parentNode.querySelector('[checked]');
                            if(checked == null){
                              checked = target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('[checked]');
                              notChecked = target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('input:not([checked])');
                            }
                            checked.removeAttribute("checked");
                            notChecked.setAttribute("checked", "");

                            this.updateSelectionMetadata(event);
                            var options = this.selectedOptionValues();
                            target = notChecked;
                            publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
                                data: {
                                    event,
                                    target,
                                    selectedOptionValues: options,
                                },
                            });

                    }

                });

                this.addEventListener('change', (event) => {
                        const target = this.getInputForEventTarget(event.target);
                        if (!target.hasAttribute("watering")) {
                            let name = target.name;
                            if (target.parentNode.name.includes("Size") || (name !== undefined && name.includes("Size"))) {
                                var elements = Array.from(this.querySelectorAll('SELECT')).filter((elemt) => elemt.name.includes('Size'));
                                if (elements.length === 0) {
                                    elements = Array.from(this.querySelectorAll('FIELDSET')).filter((elemt) => elemt.name.includes('Size'));
                                    for (let i = 0; i < elements.length; i++) {
                                        const element = elements[i];
                                        if (element !== target.parentNode) {
                                            Array.from(element.childNodes).find((e) => e.type === 'radio' && e.hasAttribute('checked'))
                                                .removeAttribute('checked');

                                            Array.from(element.childNodes).find((e) => e.type === 'radio' && e.value === target.value).setAttribute('checked', '')
                                        }
                                    }
                                } else {
                                    for (let i = 0; i < elements.length; i++) {
                                        const element = elements[i];
                                        if (element !== target.parentNode) {
                                            Array.from(element.options)
                                                .find((option) => option.getAttribute('selected'))
                                                .removeAttribute('selected');

                                            var arr = Array.from(element.options)
                                                .find((option) => option.value === target.value);
                                            arr.setAttribute('selected', 'selected');
                                        }
                                    }
                                }

                            }

                            let s = target.getAttribute("data-watering")?.trim();
                            if (s) {
                                let elementNodeListOf = document.querySelectorAll('div[watering]');
                                let element1 = document.querySelector('fieldset[waterfields]');
                                if(element1 != null){
                                    let waterFields = element1.querySelectorAll("input");
                                    var waterFieldLbl = s === "no" ? "Nein" : "Ja";
                                    for (let i = 0; i < elementNodeListOf.length; i++) {
                                        const elementNodeListOfElement = elementNodeListOf[i];
                                        var attr = elementNodeListOfElement.getAttribute('watering');
                                        if (attr === s)
                                            elementNodeListOfElement.classList.remove('hidden');
                                        else
                                            elementNodeListOfElement.classList.add('hidden');
                                    }

                                    for (let i = 0; i < waterFields.length; i++) {
                                        const waterField = waterFields[i];
                                        var attr = waterField.getAttribute('value');
                                        if (attr === waterFieldLbl)
                                            waterField.setAttribute("checked", "");
                                        else
                                            waterField.removeAttribute("checked");
                                    }
                                }
                            } else {
                                let elementNodeListOf = document.querySelectorAll('div[watering]');
                                for (let i = 0; i < elementNodeListOf.length; i++) {
                                    const elementNodeListOfElement = elementNodeListOf[i];
                                    elementNodeListOfElement.classList.add('hidden');
                                }
                            }

                            this.updateSelectionMetadata(event);
                            var options = this.selectedOptionValues();
                            publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
                                data: {
                                    event,
                                    target,
                                    selectedOptionValues: options,
                                },
                            });
                        }
                    }
                );
            }

            updateSelectionMetadata({target}) {
                const {value, tagName} = target;

                if (tagName === 'SELECT' && target.selectedOptions.length) {
                    Array.from(target.options)
                        .find((option) => option.getAttribute('selected'))
                        .removeAttribute('selected');
                    target.selectedOptions[0].setAttribute('selected', 'selected');

                    const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
                    const selectedDropdownSwatchValue = target
                        .closest('.product-form__input')
                        .querySelector('[data-selected-value] > .swatch');
                    if (!selectedDropdownSwatchValue) return;
                    if (swatchValue) {
                        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
                    } else {
                        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
                    }

                    selectedDropdownSwatchValue.style.setProperty(
                        '--swatch-focal-point',
                        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
                    );
                } else if (tagName === 'INPUT' && target.type === 'radio') {
                    const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
                    if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
                }
            }

            getInputForEventTarget(target) {
                return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
            }

            selectedOptionValues() {
                let map = Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
                    ({dataset}) => dataset.optionValueId
                );
                return map;
            }

           

        }
        if (!customElements.get('variant-selects-manuly')) {
            customElements.define(
                'variant-selects-manuly', VariantSelectsManuly);
}
